import {Basic} from "./Basic";
import {Browser} from "./Browser";
import {Chronicle} from "./Chronicle";
import {Display} from "./Display";
import {Filter} from "./Filter";
import {History} from "./History";
import {Lightbox} from "./Lightbox";
import {Load} from "./Load";
import {Podcastplayer} from "./Podcastplayer";
import {Form} from "./Form";
import {Sculpture} from "./Sculpture";

// set global variables
Basic.init();

window.addEventListener('DOMContentLoaded',function()
{
    // turn off scroll restauration
    history.scrollRestoration = 'manual';

    // get environment
    Browser.analyze();
    Display.analyze();

    // get language from HTML
    Basic.lang = document.documentElement.lang;

    // remove hover class on mobile devices
    if(Browser.mobile === true)
    {
        document.body.classList.remove('w__hover');
        document.body.classList.add('w__mobile');
    }

    // fix select padding on firefox < 107
    if(Browser.engine === 'gecko' && Browser.version < 107)
    {
        document.body.classList.add('w__fix--ff-select');
    }

    // add event listeners
    add_changeEvent();
    add_clickEvent();
    add_keyupEvent();
    add_mouseEvents();

    // replace first history element
    History.replace_url();

    // add history event
    History.add_event();
});

window.addEventListener('load',function()
{
    // activate language marker
    Basic.set_langMarker();

    // default is scrollToTop
    let scrollToTop = true;

    // get scroll target if available
    const scrollToEl = document.location.hash ? document.querySelector(document.location.hash) : '';
    if(scrollToEl)
    {
        scrollToTop = false;
    }

    // start sculpture
    const mySculptureCanvas = document.createElement('canvas');
    mySculptureCanvas.id = 'w--sculpture';
    mySculptureCanvas.classList.add('w__sculpture');
    document.body.appendChild(mySculptureCanvas);

    Basic.sculpture = new Sculpture(mySculptureCanvas);
    Basic.sculpture.build_scene();
    requestAnimationFrame(() => {
        Basic.sculpture.render();
    });
    Basic.sculpture.update_params();

    // start interactivity
    Basic.do_afterLoad(scrollToTop, scrollToEl);
});

const add_changeEvent = function()
{
    document.body.addEventListener('change',function(e)
    {
        const el = e.target;
        if(el.classList.contains('w__js-select'))
        {
            switch(el.dataset.f)
            {
                case 'service-category':
                    let activeEl = document.body.querySelector('.w__ul--service.active');
                    if(activeEl)
                    {
                        activeEl.classList.remove('active');
                    }
                    activeEl = document.getElementById('w--service-' + el.value);
                    if(activeEl)
                    {
                        activeEl.classList.add('active');
                    }
                    break;

                case 'shop-action':
                    Basic.shop._process(el);
                    break;

                default:
                    console.log('Unknown change event', el.dataset.f);
            }
        }
    });
};

const add_clickEvent = function()
{
    document.body.addEventListener('click',e =>
    {
        let el = e.target,
            linkType = 'none';

        if(el.classList.contains('ise') || el.closest('.ise'))
        {
            return false;
        }
        else if(el.classList.contains('w__js-button'))
        {
            linkType = 'js';
        }
        else if(el.classList.contains('w__el'))
        {
            linkType = 'external';
        }
        else if(el.classList.contains('w__il'))
        {
            linkType = 'internal';
        }

        else if(el.closest('.w__js-button.w__el,.w__js-button.w__il'))
        {
            el = el.closest('.w__js-button.w__el,.w__js-button.w__il');
            linkType = 'js';
        }

        else if(el.closest('.w__el'))
        {
            el = el.closest('.w__el');
            linkType = 'external';
        }
        else if(el.closest('.w__il'))
        {
            el = el.closest('.w__il');
            linkType = 'internal';
        }
        else if(el.closest('.w__js-button'))
        {
            el = el.closest('.w__js-button');
            linkType = 'js';
        }

        switch(linkType)
        {
            case "js":
                switch(el.dataset.f)
                {
                    case 'calendar':
                    case 'discography':
                    case 'media':
                    case 'news':
                    case 'projects':
                    case 'shop':
                        e.preventDefault();
                        Filter.process(el, el.dataset.f);
                        break;

                    case 'chronicle':
                        e.preventDefault();
                        Chronicle.set_active(el);
                        break;

                    case 'chronicle-nav':
                        e.preventDefault();
                        Chronicle.move_timeline(el);
                        break;

                    case 'concert-open':
                        e.preventDefault();
                        if(!el.classList.contains('active'))
                        {
                            el.classList.add('active');
                            const linkEl = el.querySelector('.w__tile--link');
                            if(linkEl)
                            {
                                History.push_url(linkEl.href,true);
                                const r = {
                                    originalUrl: linkEl.href,
                                    switchUrl: (Basic.lang === 'de')
                                        ? linkEl.href.replace('de/kalender','en/calendar')
                                        : linkEl.href.replace('en/calendar','de/kalender')
                                }
                                Basic.update_languageMenus(r);
                            }
                            window.scrollTo(0, el.getBoundingClientRect()['top'] + window.scrollY);
                        }
                        break;

                    case 'concert-close':
                        e.preventDefault();
                        el.closest('.w__concert').classList.remove('active');
                        break;

                    case 'control-confirmation':
                        const link = document.getElementById('w--control-confirmation');
                        if(link)
                        {
                            link.classList.toggle('mod--inactive');
                            link.href = link.classList.contains('mod--inactive') ? '#' : link.dataset.href;
                        }
                        break;

                    case 'discography-details':
                    case 'shop-details':
                        e.preventDefault();
                        Basic.shop.load_details(el);
                        break;

                    case 'form-toggle-condition':
                        Form.toggle_condition(el);
                        break;

                    case 'jump':
                        e.preventDefault();
                        // prevent adding internal links to history but scroll to target
                        const hash = el.href.replace(/^.*#([-\da-z]+)$/,'$1'),
                            scrollToEl = hash ? document.getElementById(hash) : '';
                        if(scrollToEl)
                        {
                            scrollToEl.scrollIntoView(true);
                        }
                        break;

                    case 'lightbox':
                        e.preventDefault();
                        new Lightbox(el);
                        break;

                    case 'lightbox-close':
                        e.preventDefault();
                        Lightbox.close(el);
                        break;

                    case 'play-audio':
                        e.preventDefault();
                        Podcastplayer.toggle_audio(el)
                        break;

                    case 'play-podcast':
                        e.preventDefault();
                        const podcast = el.closest('.w__tile').querySelector('.w__podcast--container');
                        if(podcast && podcast.player)
                        {
                            podcast.player.toggle_play(false);
                        }
                        break;

                    case 'quote':
                        e.preventDefault();
                        change_quote(el);
                        break;

                    case 'search-submit':
                        do_fulltextSearch(document.getElementById('w--search-fulltext'));
                        break;

                    case 'sculpture':
                        if(Basic.sculpture)
                        {
                            Basic.sculpture.process_click(el);
                        }
                        break;

                    case 'shop-action':
                        e.preventDefault();
                        Basic.shop._process(el);
                        break;

                    case 'shop-close':
                        e.preventDefault();
                        Basic.shop.close_details(el);
                        break;

                    case 'toggle-active':
                        e.preventDefault();
                        el.classList.toggle('active');
                        break;

                    case 'toggle-menu':
                        e.preventDefault();
                        document.getElementById('w--nav').classList.toggle('active');
                        document.body.classList.toggle('mod--menu-active');
                        const rem = el.title;
                        el.title = el.dataset.toggleText;
                        el.dataset.toggleText = rem;
                        break;

                    case 'toggle-submenu':
                        if(Display.device === 'smartphone')
                        {
                            const activeEl = document.querySelector(
                                                '#w--nav li.mod--open[data-f="toggle-submenu"]');
                            if(activeEl && activeEl !== el)
                            {
                                activeEl.classList.remove('mod--open');
                            }
                            el.classList.toggle('mod--open');
                        }
                        break;

                    case 'toggle-search':
                        e.preventDefault();
                        const searchContainer = el.closest('.w__nav--search-container');
                        if(searchContainer)
                        {
                            if(!searchContainer.classList.contains('active'))
                            {
                                document.getElementById('w--search-fulltext').value = '';
                                document.getElementById('w--search-fulltext').focus();
                                if(Basic.sculpture)
                                {
                                    Basic.sculpture.controlButton.classList.remove('active');
                                }
                            }
                            else if(Basic.sculpture &&
                                   !document.body.querySelector('#w--header .w__sculpture--play'))
                            {
                                Basic.sculpture.controlButton.classList.add('active');
                            }
                            searchContainer.classList.toggle('active');
                        }
                }
                break;

            case 'external':
                if(el.tagName.toLowerCase() !== 'a')
                {
                    window.open(el.dataset.url,'_blank','noopener,noreferrer');
                }
                break;

            case 'internal':
                e.preventDefault();
                const url = el.dataset.url ? el.dataset.url : el.href;
                Load.post({
                    f: 'load',
                    url: url
                }).then(r => {
                    Basic.update_page(r, url);
                }).catch(r => {
                    console.error(r, url);
                });
                break;
        }
    });
};

const add_keyupEvent = function()
{
    document.body.addEventListener('keyup',function(e)
    {
        const el = e.target;
        if(el.classList.contains('w__js-search'))
        {
            if(e.key.toLowerCase() === 'enter')
            {
                switch(el.dataset.f)
                {
                    case 'calendar':
                    case 'discography':
                    case 'media':
                    case 'news':
                    case 'projects':
                    case 'shop':
                        Filter.process(el, el.dataset.f);
                        break;

                    case 'fulltext-search':
                        do_fulltextSearch(el);
                        break;
                }
            }
            else
            {
                const activeEl = el.closest('.w__search--filter-item.search-active');
                if(activeEl)
                {
                    activeEl.classList.remove('search-active')
                }
            }
        }
    });
};

const do_fulltextSearch = function(el)
{
    if(el.value.trim())
    {
        Load.post({
            f: el.dataset.f,
            value: el.value.trim()
        }).then(r => {
            let url = Basic.base + Basic.lang + "/search";
            Basic.update_page(r, url,null, el.value.trim());
        }).catch(error => {
            console.log(error);
        });
    }
};

const add_mouseEvents = function()
{
    document.body.addEventListener('mouseover',function(e)
    {
        let el = e.target;

        if(el.closest('.w__linked-hover'))
        {
            el = el.closest('.w__linked-hover');
        }
        else if(el.closest('.w__mark-hover'))
        {
            el = el.closest('.w__mark-hover');
        }

        if(el.classList.contains('w__linked-hover'))
        {
            const linkedEls = document.body.querySelectorAll('.w__linked-hover[data-link-id="' +
                el.dataset.linkId + '"]');
            for(let i=0; i<linkedEls.length; i++)
            {
                if(linkedEls[i] !== el)
                {
                    linkedEls[i].classList.add('hover');
                }
            }
        }
        else if(el.classList.contains('w__mark-hover'))
        {
            Basic.set_langMarker(el);
        }
    });

    document.body.addEventListener('mouseout',function(e)
    {
        let el = e.target;

        if(el.closest('.w__linked-hover'))
        {
            el = el.closest('.w__linked-hover');
        }
        else if(el.closest('.w__mark-hover'))
        {
            el = el.closest('.w__mark-hover');
        }

        if(el.classList.contains('w__linked-hover'))
        {
            const linkedEls = document.body.querySelectorAll('.w__linked-hover[data-link-id="' +
                el.dataset.linkId + '"]');
            for(let i=0; i<linkedEls.length; i++)
            {
                if(linkedEls[i] !== el)
                {
                    linkedEls[i].classList.remove('hover');
                }
            }
        }
        else if(el.classList.contains('w__mark-hover'))
        {
            Basic.set_langMarker();
        }
    });
};

const change_quote = function(el)
{
    const container = el.closest('.w__project--quotes'),
          arrow = el.querySelector('span');
    let activeQuote = container.querySelector('.w__quote.active'),
        newQuote,
        addClassOld,
        addClassNew;

    if(el.classList.contains('mod--prev'))
    {
        newQuote = activeQuote.previousElementSibling;
        if(!newQuote || newQuote.classList.contains('w__quote--nav'))
        {
            newQuote = container.querySelector('.w__quote:last-of-type');
        }
        addClassOld = 'out-right';
        addClassNew = 'out-left';
    }
    else
    {
        newQuote = activeQuote.nextElementSibling;
        if(!newQuote || newQuote.classList.contains('w__quote--nav'))
        {
            newQuote = container.querySelector('.w__quote:first-of-type');
        }
        addClassOld = 'out-left';
        addClassNew = 'out-right';
    }

    arrow.style.transform = 'translateX(25%)';
    activeQuote.classList.add(addClassOld);
    activeQuote.classList.remove('active');
    newQuote.style.transition = 'none';
    newQuote.classList.add(addClassNew);
    setTimeout(() => {
        arrow.style.transform = '';
        newQuote.style.transition = '';
        newQuote.offsetHeight;
        newQuote.classList.add('active');
        newQuote.classList.remove(addClassNew);
        setTimeout(() =>
        {
            activeQuote.classList.remove(addClassOld);
        },250);
    },250);
};

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(Basic.resizeTimer);
    Basic.resizeTimer = requestAnimationFrame(Basic.process_resize);
});

// window scroll detection
window.addEventListener('scroll',() =>
{
    cancelAnimationFrame(Basic.scrollTimer);
    Basic.scrollTimer = requestAnimationFrame(Basic.process_scroll);
});